// The "true" at the end tells the browser to intercept the click in the Capture Phase,
// bypassing any event.stopPropagation() blocks from the messy theme.
document.addEventListener('click', function(event) {
  
  const searchIcon = event.target.closest('.search-toggler');
  
  // If it WAS the search icon, proceed
  if (searchIcon) {
    const searchInput = document.getElementById('searchInput');
    
    if (searchInput) {
      console.log('Intercepted the click! Setting focus...');
      setTimeout(function() {
        searchInput.focus();
      }, 100); 
    } else {
      console.log('Search toggler clicked, but #searchInput is missing.');
    }
  }
  // We removed the final 'else' block so it stops spamming your console 
  // on every random click on the page.

}, true); // <-- This 'true' is the magic bullet